export default "__VITE_ASSET__DJ78qIkc__"